import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Facebook, Linkedin, Instagram, Twitter, Youtube } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { publicApi } from '../../api/client';
import './Footer.css';

export default function Footer() {
  const { t, isRTL } = useLanguage();
  const [publicSettings, setPublicSettings] = useState({});

  useEffect(() => {
    let mounted = true;
    publicApi
      .settings()
      .then((res) => {
        if (mounted && res?.settings) setPublicSettings(res.settings);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  const siteName = publicSettings.siteName || 'Tarjemlek';
  const siteDescription = publicSettings.siteDescription || t.footer.description;
  const phone = publicSettings.contactPhone || '+216 71 234 567';
  const email = publicSettings.contactEmail || 'contact@tarjemlek.tn';
  const address = publicSettings.contactAddress || t.footer.address;

  const socials = [
    { key: 'socialFacebook', icon: Facebook, label: 'Facebook' },
    { key: 'socialTwitter', icon: Twitter, label: 'Twitter' },
    { key: 'socialLinkedIn', icon: Linkedin, label: 'LinkedIn' },
    { key: 'socialInstagram', icon: Instagram, label: 'Instagram' },
    { key: 'socialYouTube', icon: Youtube, label: 'YouTube' },
    { key: 'socialWhatsApp', icon: Phone, label: 'WhatsApp' },
  ];

  return (
    <footer className={`footer ${isRTL ? 'rtl' : ''}`}>
      <div className="footer-main">
        <div className="container grid-4 footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="footer-logo-name">{siteName}</span>
              <span className="footer-logo-ar">ترجملك</span>
            </Link>
            <p>{siteDescription}</p>
            <div className="footer-social">
              {socials.map(({ key, icon: Icon, label }) => {
                const url = publicSettings[key];
                if (!url) return null;
                return (
                  <a key={key} href={url} target="_blank" rel="noopener noreferrer" aria-label={label}>
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4>{t.footer.services}</h4>
            <ul>
              <li><Link to="/services">{t.services.legal}</Link></li>
              <li><Link to="/services">{t.services.certified}</Link></li>
              <li><Link to="/services">{t.services.academic}</Link></li>
              <li><Link to="/services">{t.services.apostille}</Link></li>
            </ul>
          </div>

          <div>
            <h4>{t.footer.company}</h4>
            <ul>
              <li><Link to="/about">{t.nav.about}</Link></li>
              <li><Link to="/faq">{t.nav.faq}</Link></li>
              <li><Link to="/translator">{t.nav.translator}</Link></li>
              <li><Link to="/contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <h4>{t.nav.contact}</h4>
            <ul className="footer-contact">
              <li>
                <MapPin size={16} />
                {address}
              </li>
              <li>
                <Phone size={16} />
                <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
              </li>
              <li>
                <Mail size={16} />
                <a href={`mailto:${email}`}>{email}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>&copy; {new Date().getFullYear()} {siteName}. {t.footer.rights}</p>
          <div className="footer-legal">
            <Link to="/legal">{t.footer.legal}</Link>
            <Link to="/privacy">{t.footer.privacy}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
